// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// Both of these packages were/are meant to provide additional support for IE.
// Babel Polyfill provides a number of useful polyfills, but there was a significant
// rewrite to some of our code to accomodate IE, and it may not be necessary.
// The fetch polyfill could be refactored out at this point. See the getSVG()
// method in abstract/Vector.vue for more info.
import "babel-polyfill";
import 'whatwg-fetch';

import Vue from 'vue';
import VTooltip from 'v-tooltip';
import store from './store';
import App from './App';

Vue.use(VTooltip);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	components: { App },
	template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js